import React from 'react';
import { Button as OrcButton } from '@ontruck/orc';

const Button = ({ className, error, success, successText, errorText, onClick, text }) => {
  return (
    <div className={className}>
      {success && <div className="feedback feedback__success">{successText}</div>}
      {error && <div className="feedback feedback__error">{errorText}</div>}
      {!success && !error && (
        <OrcButton className="button button-assign" onClick={onClick} text={text} fullWidth />
      )}
    </div>
  );
};

export default Button;
